import { ReduxHelper } from "helpers";
import {
  IDeliveryOrder,
  IDeliveryOrderDetail,
  IGetDeliveryOrderDetail,
  IPaginateApiResponse,
  IPaginationRequest,
  IUpdateDeliveryOrderRequest,
} from "model";

export const prefix = "DELIVERY_ORDER";

export const getAllDeliveryOrders = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IDeliveryOrder[]>
>(prefix, "GET_ALL_DELIVERY_ORDER");
export const getDeliveryOrderDetail = ReduxHelper.generateActions<
  IGetDeliveryOrderDetail,
  IPaginateApiResponse<IDeliveryOrderDetail[]>
>(prefix, "GET_DELIVERY_ORDER_DETAIL");
export const updateDeliveryOrder = ReduxHelper.generateActions<
  IUpdateDeliveryOrderRequest,
  IDeliveryOrder
>(prefix, "UPDATE_DELIVERY_ORDER");
